import { useContext, useState } from 'react';
import './login.css';
import LinkButton from '../components/common/linkButton/linkButton';
import { login, register } from '../services/userService';
import { AuthContext } from '../contexts/authContext';
import { useNavigate } from 'react-router-dom';
import routes from '../constants/routes';
import Spinner from '../components/common/spinner/spinner';
import Title from "../components/common/title/title";

function LoginForm({ routeToNavigate }) {
    const [isSignUp, setIsSignUp] = useState(false);
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState('');
    const { loginContext } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        console.log('start login');
        e.preventDefault();
        setError('');

        if (email === '' || password === '' || (isSignUp && (name === '' || phone === ''))) {
            setError('נא למלא את כל השדות');
            return;
        }

        try {
            setIsLoading(true);
            if (isSignUp) {
                const { token, user } = await register({ name, phone, email, password });
                loginContext(user, token);
                console.log('נרשמת בהצלחה');
            } else {
                const { token, user } = await login({ email, password });
                loginContext(user, token);
                console.log('התחברת בהצלחה');
            }

            navigate(routeToNavigate != null ? routeToNavigate : routes.home);
        } catch (err) {
            setError('התרחשה שגיאה, בדוק את הפרטים ונסה שוב');
        }
        setIsLoading(false);
    };

    return (
        <div className="login-form-wrapper">
            <Title text="התחברות" />
            <form className="login-form" onSubmit={handleSubmit}>
                {isSignUp && (
                    <>
                        <input
                            className='login_input'
                            type="text"
                            placeholder="שם מלא"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                        <input
                            className='login_input'
                            type="tel"
                            placeholder="טלפון"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                        />
                    </>
                )}
                <input
                    className='login_input'
                    type="email"
                    placeholder="אימייל"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <input
                    className='login_input'
                    type="password"
                    placeholder="סיסמה"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
                <button type={"submit"} >{isSignUp ? 'הרשמה' : 'התחברות'} {isLoading ? (<Spinner />) : ('')} </button>
                {error && <p className="error-message">{error}</p>}
                <div className="register-prompt">
                    <span>{isSignUp ? 'כבר רשום?' : 'לא רשום עדיין?'}</span>
                    <LinkButton
                        onClick={() => setIsSignUp(!isSignUp)}
                        text={isSignUp ? 'להתחברות' : 'להרשמה'}
                        color={'black'}
                        fontSize={'0.8rem'}
                    />
                </div>
            </form>
        </div>
    );
}

export default LoginForm;
